module.exports = __webpack_public_path__ + "img/pr-1.21c8f7d0.png";